import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class CustomerSupportService {
    constructor(private http: HttpClient) {
    }

    getRecommendation(id) {
        return this.http.get('/agri/crm/getRecommendation?recommendationId=' + id);
    }
    getRecommendations() {
        return this.http.get('/agri/crm/getAllRecommendations');
    }
    deleteRecommendation(id){
        return this.http.delete('/agri/crm/deleteRecommendation?recommendationId='+id);
    }

    getContactForm(id) {
        return this.http.get('/agri/crm/getContactForm?recommendationId=' + id);
    }
    getContactForms() {
        return this.http.get('/agri/crm/getContactForms');
    }
    deleteContactForm(id){
        return this.http.delete('/agri/crm/deleteContactForm?contactFormId='+id);
    }

    changeContactFormStatus(contactFormId, status){
        return this.http.get('/agri/crm/changeContactFormStatus?contactFormId='+ contactFormId +'&status='+status);
    }
    changeRecommendationStatus(recommendationId, status){
        return this.http.get('/agri/crm/changeRecommendationStatus?recommendationId='+ recommendationId +'&status='+status);
    }
}
